<template>
  <div class="networkError">
    <h1>Ooops!</h1>

    <h3>
      Sembra che ci sia un problema di rete. Per favore attendi un momento e 
      <a href="#" @click="$router.go(-1)">clicca qui</a> per riprovare.
    </h3>
  </div>
</template>